import { RefObject } from 'react';
import { twJoin } from 'tailwind-merge';

type StickyBarProps = {
    stickyRef: RefObject<HTMLDivElement> | null;
    isSticky: boolean;
    dataTestId?: string;
};

const TEST_IDENTIFIER = 'sticky-bar';

const StickyBar: FC<StickyBarProps> = ({ stickyRef, isSticky, dataTestId, children }) => {
    return (
        <div
            className={twJoin(
                'top-[-1px] left-0 right-0 z-stickyBar transition-shadow',
                isSticky ? 'sticky bg-white shadow-grayDown' : 'static bg-none shadow-none',
            )}
            ref={stickyRef}
            data-testid={dataTestId ?? TEST_IDENTIFIER}
        >
            {children}
        </div>
    );
};

export default StickyBar;
